import { Component, OnInit, EventEmitter } from '@angular/core';
import { UploadFile, UploaderOptions, UploadInput, humanizeBytes, UploadOutput } from 'ngx-uploader';
import { environment } from '../../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { UserModel } from 'src/app/models/user.model';
import { MessageService } from 'primeng/api';
import { Sharedservice } from 'src/app/shared-components/shared.service';
//import { element } from '@angular/core';
// tslint:disable-next-line:max-line-length
import { DownloadUploadFlatfileComponentmessage, severitymessage, FunctionalityNames, LanguageConstants } from '../../shared-components/constant';
import { saveAs } from 'file-saver';
import { DatabookcompareService } from 'src/app/services/databookcompare.service';
import { ErrorPopUpModel } from '../../models/errorpopup.model';
import { MasterHelpModel } from 'src/app/models/MasterHelp.model';
import { MasterHelpService } from 'src/app/services/masterhelp.service';
import { InfraService } from 'src/app/services/infra.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'app-comparedatabook',
  templateUrl: './comparedatabook.component.html',
  styleUrls: ['./comparedatabook.component.css']
})
export class ComparedatabookComponent implements OnInit {
  private EnvName = environment.ENV;
  options: UploaderOptions;
  sourceFiles: UploadFile[];
  private loggedInUserId: number;
  uploadInput: EventEmitter<UploadInput>;
  humanizeBytes: Function;
  dragOver: boolean;
  loadspinner = false;
  databookCompareloadspinner = false;
  cellvaluediff: { Sheetname: string, count: number }[];
  public disablestatus = false;
  public disableonstatus = true;
  public showfilename = false;
  configUrl: string;
  engagementId = 1;
  i = 0;
  flatFileStepId: number;
  flatfile: any;
  data: any;
  loadspinnerflatfile = false;
  private flatFileTemplateDownloadUrl: string;
  errorModel: ErrorPopUpModel = new ErrorPopUpModel();
  showNextButton = false;
  isTempFlatfileUploaded: number;
  private maxsize = environment.maxFileSize * 1024 * 1024;
  private maxFlatFileSizeUploadLimit = environment.maxFlatFileSizeUploadLimit * 1024 * 1024;
  private minFlatFileSizeToSendEmail = environment.minFlatFileSizeToSendEmail;
  timeOutHandler: NodeJS.Timer;
  timeOutHandlerFlatFileDownload: NodeJS.Timer;
  isTimeIntervalInProgress = false;
  isTimeIntervalInProgressFlatFileDownload = false;
  uploadedFlatFileName = '';
  private selectedTemplate: number;
  helpMenu1: MasterHelpModel = new MasterHelpModel();
  display = false;
  show = false;
  notificationDisplay = false;
  counttable = false;
  difftable = false;
  file1: string;
  SheetcountFlag = 0;
  uploadFileList: any = [];
  // primeng table
  celldifferences: any;
  filechanges: any = [];
  langCode: string;
  currLangTranslation: any;
  constructor(private infraService: InfraService, private route: ActivatedRoute, private userService: UserService,
    private messageService: MessageService, public router: Router, public sharedService: Sharedservice
    , private databookcompareService: DatabookcompareService, private masterHelpService: MasterHelpService, private translateService: TranslateService) {
    this.options = {
      concurrency: 1,
      // maxUploads: 1,
      allowedContentTypes: [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/msexcel',
        'application/vnd.ms-excel',
        'application/vnd.ms-excel.sheet.macroEnabled.12']
    };
    this.infraService.infraDetails$.subscribe(data => {
      this.selectedTemplate = data.TemplateId;
      this.configUrl = data.WebEndPoint2 + 'CompareDatabook/UploadDatabookToCompare/';
      // this.flatFileTemplateDownloadUrl = data.      // this.flatFileTemplateDownloadUrl = data.WebEndPoint1 + 'filedownload/template/' + this.engagementId;
 + 'filedownload/template/' + this.engagementId;
    });
    this.sourceFiles = []; // local uploading files array
    this.uploadInput = new EventEmitter<UploadInput>(); // input events, we use this to emit data to ngx-uploader
    this.humanizeBytes = humanizeBytes;
    this.flatFileStepId = 1;

    this.userService.cast.subscribe((userData: UserModel) => {
      if (userData.Id !== undefined) {
        this.loggedInUserId = userData.Id;
      }
    });
  }

  ngOnInit() {
    this.langCode = localStorage.getItem(LanguageConstants.LANG_CODE);
    this.currLangTranslation = this.translateService.translations[this.langCode];
    this.translateService.onLangChange.subscribe((langEvent: LangChangeEvent) => {
      this.currLangTranslation = langEvent.translations;
    });

    if (this.EnvName === 'Prod') {
      this.router.navigate(['/home']);
    }
  }

  onUploadOutput(output: UploadOutput, fileInput: any): void {
    this.counttable = false;
    this.difftable = false;
    if (output.type === 'allAddedToQueue') { // when all files added in queue
      // uncomment this if you want to auto upload files when added
      if (this.sourceFiles.length === 2) {
        for (const file of this.sourceFiles) {

          this.uploadFileList.push(file.name);
          this.i++;
        }
        this.loadspinner = true;
        this.uploadedFlatFileName = this.sourceFiles[0].name;
        const event: UploadInput = {
          type: 'uploadAll',
          url: this.configUrl,
          method: 'POST',
          data: { File1: <any>this.sourceFiles[0].name, File2: <any>this.sourceFiles[1].name }
          // tslint:disable-next-line:max-line-length
          , headers: { 'Authorization': 'Bearer ' + (environment.isBearerAuthorizationEnabled ? localStorage['dbamsaltoken'] : environment.sampleToken) }
        };
        this.uploadInput.emit(event);
        this.engagementId = this.engagementId + 1;
      }
    } else if (output.type === 'addedToQueue' && typeof output.file !== 'undefined') { // add file to array when added
      if (output.file.size > this.maxFlatFileSizeUploadLimit) {
        this.loadspinner = false;
        fileInput.value = '';
        this.errorModel.confirmIsDisplay = true;
        this.errorModel.displayMessage = this.currLangTranslation.severitymessage.MaxsizeError + ' ' + output.file.name + '  ' +
          ' of size more than ' + environment.maxFlatFileSizeUploadLimit + ' MB';
      } else {
        this.uploadFileList = [];
        const time = new Date();
        const extension = output.file.name.slice((output.file.name.lastIndexOf('.') - 1 >>> 0) + 2);
        output.file.name = output.file.name.replace('.' + extension, '_' + time.getTime() + '.' + extension);
        this.sourceFiles.push(output.file);
      }
    } else if (output.type === 'uploading' && typeof output.file !== 'undefined') {
      this.engagementId = this.engagementId + 1;

      // update current data in files array for uploading file
      const index = this.sourceFiles.findIndex(file => typeof output.file !== 'undefined' && file.id === output.file.id);
      this.sourceFiles[index] = output.file;
    } else if (output.type === 'done' && typeof output.file !== 'undefined') {
      if (output.file.response && output.file.response.msg) {
        const uploadedFileIndex = this.uploadFileList.indexOf(output.file.name);
        if (uploadedFileIndex >= 0) {
          this.uploadFileList[uploadedFileIndex] = output.file.response.msg;
        }
      }

      // if (this.sourceFiles[0].response.status === 400) {
      //  this.loadspinner = false;
      //  this.messageService.add({
      //    key: this.currLangTranslation.severitymessage.key, severity: this.currLangTranslation.severitymessage.error,
      //    summary: this.currLangTranslation.severitymessage.notification,
      //    detail: this.currLangTranslation.severitymessage.FormateError, sticky: true, closable: true
      //  });
      // } else {
      //
      if (this.sourceFiles[1].response.status === severitymessage.success) {
        this.disablestatus = true;
        this.disableonstatus = false;
        this.loadspinner = false;
        this.showfilename = true;
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key, severity: severitymessage.success,
          summary: this.currLangTranslation.severitymessage.notification, sticky: true, closable: true
        });

      } else if (this.sourceFiles[0].response.message && this.sourceFiles[0].response.message !== '') {
        this.loadspinner = false;
        this.errorModel.confirmIsDisplay = true;
        this.errorModel.displayMessage = this.sourceFiles[0].response.message;
      } else {
        this.loadspinner = false;
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification,
          detail: this.currLangTranslation.severitymessage.somethingwrong, sticky: true, closable: true
        });
      }
      // }
      this.sourceFiles = [];

      // Clear file - to upload same file name twice
      fileInput.value = '';
    } else if (output.type === 'rejected' && typeof output.file !== 'undefined') {
      // Replace with Notification service
      this.messageService.add({
        key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error,
        summary: this.currLangTranslation.severitymessage.notification,
        detail: this.currLangTranslation.severitymessage.FormateError, sticky: true, closable: true
      });
      fileInput.value = '';
      this.loadspinner = false;
    } else if (output.type === 'removed') {

      // remove file from array when removed
      this.sourceFiles = this.sourceFiles.filter((file: UploadFile) => file !== output.file);
      this.loadspinner = false;
    } else if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
      this.dragOver = false;
    } else if (output.type === 'drop') {
      this.dragOver = false;
    }
  }

  compareDatabook() {
    this.databookCompareloadspinner = true;
    for (const filename of this.uploadFileList) {
    }
    this.file1 = this.uploadFileList.join();

    this.databookcompareService.getCompareDatabookData(this.file1).subscribe((resp: any[]) => {
      this.data = resp;
      this.filechanges = [
        {
          sheetcountFlag: this.data['sheetcountFlag'],
          worksheetfile1count: this.data['worksheetfile1count'],
          worksheetfile2count: this.data['worksheetfile2count'],
          notmatchedsheet: this.data['notmatchedsheet'],
          notmatchedsheetname: this.data['notmatchedsheetname']
        }
      ];
      this.counttable = true;
      if (this.data['compareResults'] != null) {
        this.celldifferences = this.data['compareResults'];
        this.difftable = true;

      }

      this.databookCompareloadspinner = false;
    });

    this.disablestatus = false;
    this.disableonstatus = true;
  }

  cancelUpload(id: string): void {
    this.uploadInput.emit({ type: 'cancel', id: id });
  }

  removeFile(id: string): void {
    this.uploadInput.emit({ type: 'remove', id: id });
  }

  removeAllFiles(): void {
    this.uploadInput.emit({ type: 'removeAll' });
  }

  confirmdisplay = false;
  closeEventFlatFile($event) {
    this.confirmdisplay = $event;
  }

  OkNotificationDisplay() {
    this.notificationDisplay = false;
  }
}
